module.exports = __webpack_public_path__ + "e9062265c973b4ab42aa70eb66ea8957.svg";